<template>
  <div class="common-table">
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="headerStyle"
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="table.hasSelect"
        type="selection"
        reserve-selection
        width="55"
        align="center"
      ></el-table-column>
      <el-table-column type="index" width="150" label="序号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(column, index) in table.columns"
        :prop="column.prop"
        :key="index"
        :label="column.label"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="column.type">
            <span v-if="column.type == 'is_achievement'">
              {{
                scope.row.isAchievement === 1 && scope.row.isMarket === 1
                  ? '双平台'
                  : scope.row.isMarket === 1
                  ? '大市场平台'
                  : '成果交易平台'
              }}
            </span>
            <span v-if="column.type == 'status_pop' && scope.row['over_status'] != 1">
              <el-tag type="danger" v-if="scope.row[column.prop] == 3">待审核</el-tag>
              <el-tag
                type="info"
                v-else-if="
                  scope.row[column.prop] == 2 ||
                    scope.row['status1'] == 2 ||
                    scope.row['status2'] == 2 ||
                    scope.row['status3'] == 2
                "
              >
                审核未通过
              </el-tag>
              <!-- <el-tag type="success" v-else-if="scope.row['status3'] == 1">审核通过</el-tag>
              <el-tag type="primary" v-else>审核中</el-tag> -->
              <el-tag type="success" v-else-if="scope.row['status3'] == 1 && scope.row['sign_image_market'] === null">待签名</el-tag>
              <el-tag type="success" v-else-if="scope.row['status3'] == 1 && scope.row['sign_image_market'] !== null && scope.row['sign_image_achievement'] === null">签名中</el-tag>
              <el-tag type="success" v-else-if="scope.row['status3'] == 1 && scope.row['sign_image_market'] !== null && scope.row['sign_image_achievement'] !== null">审核通过</el-tag>
              <el-tag type="warning" v-else>审核中</el-tag>
            </span>
            <span
              v-if="column.type == 'status_pop' && scope.row['over_status'] == 1"
              class="pointer"
              @mouseover="mouseoverEvent(scope.row, scope.row[column.prop])"
            >
              <el-tag type="primary">已完结</el-tag>
            </span>
            <span v-if="column.type == 'status'">
              <el-tag type="success" v-show="scope.row[column.prop] == 1">
                {{ column.moreText ? '初审' : '' }}通过
              </el-tag>
              <el-tag type="info" v-show="scope.row[column.prop] == 2">
                {{ column.moreText ? '初审' : '' }}未通过
              </el-tag>
              <el-tag type="danger" v-show="scope.row[column.prop] == 3">
                待{{ column.moreText ? '初审' : '审核' }}
              </el-tag>
              <el-tag type="primary" v-show="scope.row[column.prop] == 4">已完结</el-tag>
              <el-tag type="danger" v-show="scope.row[column.prop] == 5">
                {{ column.moreText ? '复审' : '' }}未通过
              </el-tag>
              <el-tag type="success" v-show="scope.row[column.prop] == 6">
                {{ column.moreText ? '复审' : '' }}已通过
              </el-tag>
              <el-tag type="success" v-show="scope.row[column.prop] == 21">材料已上传</el-tag>
            </span>
            <span v-show="column.type == 'area'">{{ getArea(scope.row[column.prop]) }}</span>
            <span v-show="column.type == 'view_duration'">
              {{ getDate(scope.row[column.prop]) }}
            </span>
            <span v-show="column.type == 'comm_type'">
              {{ scope.row[column.prop] }} （{{
                scope.row[column.type] ? phoneType[scope.row[column.type] - 1] : ''
              }}）
            </span>
            <span v-if="column.type == 'examination_status'">
              <el-tag type="info" v-show="scope.row[column.prop] == 1">待受理</el-tag>
              <el-tag type="danger" v-show="scope.row[column.prop] == 2">受理未通过</el-tag>
              <el-tag type="success" v-show="scope.row[column.prop] == 3">受理通过</el-tag>
              <el-tag type="success" v-show="scope.row[column.prop] == 4">委托合同上传完成</el-tag>
              <el-tag type="danger" v-show="scope.row[column.prop] == 5">材料上传完成</el-tag>
              <el-tag type="success" v-show="scope.row[column.prop] == 6">复审未通过</el-tag>
              <el-tag type="success" v-show="scope.row[column.prop] == 7">复审通过</el-tag>
              <el-tag type="primary" v-show="scope.row[column.prop] == 8">评审完结</el-tag>
            </span>
          </span>
          <span v-else-if="column.prop == 'contract_amount'">
            {{ Math.ceil(scope.row[column.prop] * 10000) }}
          </span>
          <span v-else :class="setClassName(column)">{{ scope.row[column.prop] }}</span>
          <span class="downSp" v-show="column.prop == 'down'">
            <el-button
              type="primary"
              size="mini"
              @click="exportOut('Technology_Skill/download/contract/' + scope.row.id)"
            >
              技术合同
            </el-button>
            <!-- <el-button
              type="danger"
              size="mini"
              @click="preview('Technology_Skill/download/cert/' + scope.row.id)"
              :disabled="scope.row.status3 != 1"
            >
              登记证明
            </el-button> -->

            <!-- <el-button type="primary" size="mini" @click="preview(scope.row.file_watermark)">
              技术合同
            </el-button> -->
            <el-button
              type="danger"
              size="mini"
              @click="preview(scope.row.contract_file)"
              :disabled="scope.row.status3 != 1"
            >
              登记证明
            </el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300" v-if="table.hasBtn" align="center">
        <template slot-scope="scope">
          <el-button
            :type="item.type"
            size="small"
            v-for="(item, index) in table.btns"
            :key="index"
            @click="clickEvent(item, scope.row)"
          >
            {{ item.name }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="display: flex; justify-content: center">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="current_page"
        :page-size="per_page"
        layout="total, prev, pager, next"
        :total="total"
        style="text-align: left; margin: 20px 0"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { isNull } from 'util';
import { CodeToText, TextToCode } from 'element-china-area-data';
import { FormatSeconds } from '../../../utils/tool';
import { encode } from 'js-base64';
export default {
  props: ['table', 'url'],
  data() {
    return {
      current_page: 1,
      per_page: 10,
      total: 10,
      headerStyle: {
        color: '#623AA2',
        background: '#E5F3FE',
      },
      tableData: [],
      phoneType: ['电话', '手机号', '微信号'],
    };
  },
  methods: {
    //导出
    exportOut(url) {
      var a = document.createElement('a');
      a.href = this.urlConfig.url + url;
      console.log('下载地址', this.urlConfig.url + url);
      a.download = '';
      a.setAttribute('target', '_blank');
      a.click();
    },
    preview(url) {
      // kkfile 在线预览第一页
      // this.http.get(`http://47.101.48.192:18012/getPreviewFirst?url=${encodeURIComponent(encode(url))}`)
      //   .then(res => {
      //     window.open(`http://47.101.48.192:18012/${res}`);
      // kkfile 在线预览全部
          // window.open(`http://47.101.48.192:18012/${this.urlConfig.imgUrl + url}`);
        // });
      // kkfile 在线预览
      const result = 'https://devfile.gsisc.cn/' + url;
      const resultUrl = encodeURIComponent(encode(result));
      console.log(`http://47.101.48.192:18012/onlinePreview?url=${resultUrl}&officePreviewType=pdf`);
      window.open(
        `http://47.101.48.192:18012/onlinePreview?url=${resultUrl}&officePreviewType=pdf`
      );
    },
    // 设置cell 类名
    setClassName(item) {
      return item?.class || '';
    },
    // 计算时长转换

    getDate(num) {
      let tmp = FormatSeconds(num);

      return tmp;
    },

    getArea(value) {
      return CodeToText[value[0]] + '' + CodeToText[value[1]];
    },
    clickEvent(item, row) {
      this.$emit(item.event, row);
    },
    handleCurrentChange(val) {
      this.getData(`${this.url}&page=${val}`);
    },
    getData(url) {
      let params = {};
      if(url.indexOf('?') > -1){
          let urlParams = url.split('?')[1]?.split('&')
          urlParams.forEach(item => {
              params[item.split('=')[0]] = item.split('=')[1]
          })
      }
      if(url.indexOf('live_vrecord')>-1){
        url = `${urlConfig.devUrl}apij2/admin-api/trade/live-viewing-record/page`
      }else{
        url = `${urlConfig.devUrl}apij2/admin-api/signature/technology-skill/page`
      }
      this.http.post(url, params).then(res => {
      // this.http.get(url).then(res => {
        if (res.code == 0) {
          res.data.data.forEach(item => {
            if (isNull(item.status)) {
              item.status = 3;
            }
          });
          this.tableData = res.data.data;
          this.per_page = res.data.per_page;
          this.total = res.data.total;
          this.current_page = res.data.current_page;
        } else {
          this.$message.error('获取数据失败！！');
        }
      });
    },
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val);
    },
  },
  watch: {
    url: {
      handler(val) {
        if (val) {
          this.getData(val);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.downSp {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  button {
    margin: 5px 0;
  }
}
</style>
